import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df819366&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=df819366&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df819366",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df819366')) {
      api.createRecord('df819366', component.options)
    } else {
      api.reload('df819366', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=df819366&scoped=true&", function () {
      api.rerender('df819366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/partials/red_packet/index.vue"
export default component.exports